import type { CatalogueEntry } from "../types";
import imageLight from "../images/g-naf-core.light.webp";
import imageDark from "../images/g-naf-core.dark.webp";

export const entry: CatalogueEntry = {
  slug: "g-naf-core",
  displayName: `G-NAF Core`,
  datasetProductCode: `G-NAF CORE`,
  subtitle: `Streamlined Access to Essential Geocoded Address Data.`,
  shortDescription: `The Geocoded National Address File (G-NAF) is Australia's most trusted, geocoded address file. Over 50 million contributed addresses are distilled into more than 15.2 million G-NAF addresses every quarter. It contains the state, suburb, street, number and coordinate reference (or 'geocode') for street addresses in Australia. G-NAF does not contain any personal information or details relating to an individual.

G-NAF Core reduces the complexity of G-NAF by delivering the data in a simplified table model. This reduces the need to select fields and build data relationships to access G-NAF's essential address data, making it easier to use with less technical effort.`,
  metadata: {
    dateAdded: 1661126400000,
    dataType: ["Points"],
    totalFeatureCount: 15530436,
    updateFrequency: `Quarterly`,
    license: `Modified CC BY 4.0`,
    licenseLink: `https://geoscape.com.au/request-g-naf-core`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/projects/gnaf_release/en/stable/index.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/projects/gnafcore_info/en/stable/index.html`,
  imageLight,
  imageDark,
  searchTags: `G-NAF Core GNAF Core Address Access Efficiency Flattened G-NAF Geospatial Integration Simplified Data Single-Table G-NAF Streamlined Access Usability`,
  detail: () => import("../details/g-naf-core").then((m) => m.detail),
};

export default entry;
